import type { FC, ReactElement } from 'react'
import styled from 'styled-components'

import type { FreeGuidesLandingPageRecord } from '@/graphql/FreeGuidesLandingPage'

import { CentredContentBlock } from '@/components/blocks/CentredContentBlock'
import { LogoDropdown } from '@/components/blocks/LogoDropdown/LogoDropdown'

const StyledFreeGuideLandingPage = styled.div`
  .three-column-feature {
    padding: 0;
    margin: 0 -20px;

    a {
      font-size: ${(p) => p.theme.v2.typography.body.s.fontSize};
    }
    p {
      font-size: ${(p) => p.theme.v2.typography.body.xs.fontSize};
    }
  }
`

const StyledTextContainer = styled.div`
  margin: 0 auto;

  h2 {
    font-size: ${(p) => p.theme.v2.typography.display.s.fontSize};
    line-height: ${(p) => p.theme.v2.typography.display.s.lineHeight};
    font-family: ${(p) => p.theme.v2.font.nantes};
    color: ${(p) => p.theme.v2.onSurface.text};
    text-align: center;
    max-width: 620px;
    margin-top: 0;
    margin-bottom: 0;
    max-width: 800px;

    @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
      margin-top: 24px;
    }
  }
  p {
    font-size: ${(p) => p.theme.v2.typography.body.m.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.m.lineHeight};
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
    color: ${(p) => p.theme.v2.onSurface.text};
    margin: 16px auto 0;
    max-width: 800px;
  }
`

type FreeGuidesLandingPageContentBlock = FreeGuidesLandingPageRecord['content'][number]

const renderBlock = (record: FreeGuidesLandingPageContentBlock): ReactElement | null => {
  switch (record.__typename) {
    case 'CentredContentBlockRecord':
      return (
        <StyledTextContainer key={record.id}>
          {/* @ts-expect-error — CentredContentBlock is still typed by the hand-written DatoCMS record */}
          <CentredContentBlock record={record} />
        </StyledTextContainer>
      )

    case 'LogoDropdownRecord':
      return <LogoDropdown record={record} key={record.id} />

    case 'ImageAndTextBlockRecord':
      return null

    default:
      record satisfies never
      return null
  }
}

export const FreeGuidesLandingPageContent: FC<{ content: FreeGuidesLandingPageContentBlock[] }> = ({ content }) => {
  return <StyledFreeGuideLandingPage>{content?.map(renderBlock)}</StyledFreeGuideLandingPage>
}
